



















































import Vue from 'vue'
import { QuestionViewModel } from '@/models/QuestionViewModel'

export default Vue.extend({
  name: 'QuestionTextParaphrase',
  components: {
  },
  props: {
    questionModel: {
      default: new QuestionViewModel(),
      type: QuestionViewModel,
      required: true
    },
    needsParaphrase: {
      default: true,
      type: Boolean
    }
  },
  data: () => ({
    selectionStart: 0,
    selectionEnd: 0,
    txtLoading: false,
    wasParaphraseEdited: false,
    origText: '',
    paraText: '',
    timer: 0
  }),
  computed: {
    selectionLength () {
      console.log('selection start: ' + this.selectionStart)
      console.log('selection end: ' + this.selectionEnd)
      return Math.abs(this.selectionStart - this.selectionEnd)
    },
    selectionText () {
      let start = Math.min(this.selectionStart, this.selectionEnd)
      let end = Math.max(this.selectionStart, this.selectionEnd)
      if (this && this.questionModel && this.questionModel.origAnswerText) {
        return this.questionModel.origAnswerText.substring(start, end)
      } else {
        return ''
      }
    }
  },
  methods: {
    onOriginalInputChanged () {
      console.log('in onOriginalInputChanged')
      this.getParaphraseForCurrent()
      // if (this.timer) {
      //   clearTimeout(this.timer)
      // }
      // this.timer = setTimeout(() => {
      //   this.getParaphraseForCurrent()
      //   this.timer = 0
      // }, 500)
    },
    onParaphraseInputChanged () {
      if (this.questionModel) {
        this.questionModel.wasParaEdited = true
      }
    },
    onSelectionChanged (e: any) {
      let txtArea = e.srcElement
      // obtain the index of the first selected character
      this.selectionStart = txtArea.selectionStart
      // obtain the index of the last selected character
      this.selectionEnd = txtArea.selectionEnd
    },
    getParaphraseForCurrent (): Promise<void> {
      let textToPara = this.selectionText || this.questionModel.origAnswerText
      console.log('paraphrasing this text:')
      console.log(textToPara)
      let questionModel = this.questionModel
      this.txtLoading = true
      return this.$store.dispatch('getParaphrase', textToPara)
        .then((paraphrased: string): Promise<void> => this.replaceTextWithParaphrase(paraphrased))
    },
    resetSelection (e: any) {
      this.selectionStart = 0
      this.selectionEnd = 0
    },
    replaceTextWithParaphrase (paraphrase: string) {
      let allText = this.questionModel.origAnswerText || ''
      let start = Math.min(this.selectionStart, this.selectionEnd)
      let end = Math.max(this.selectionStart, this.selectionEnd)

      if ((start - end) === 0) {
        start = 0
        end = allText.length
      }

      // get text parts
      let textStart = allText.substring(0, start)
      let textEnd = allText.substring(end, allText.length)
      let newText = ''
      if (paraphrase) {
        newText = textStart + paraphrase + textEnd
        end = start + paraphrase.length
      } else {
        newText = allText
      }
      let input = (this.$refs.TxtResponse as any).$refs.input
      input.focus()
      // this.insertTextIntoUndoHistory(input, newText) // TODO: fix undo
      this.questionModel.origAnswerText = newText
      this.questionModel.paraAnswerText = newText
      console.log(`selectionStart: ${start} selectionEnd: ${end}`)
      this.$nextTick(() => {
        input.selectionStart = start
        input.selectionEnd = end
        this.txtLoading = false
      })
      return Promise.resolve()
    },
    insertTextIntoUndoHistory (input: any, text: string) {
      let textEvent = document.createEvent('TextEvent')
      console.log(textEvent);
      (textEvent as any).initTextEvent('textInput', true, true, window, text)
      input.dispatchEvent(textEvent)
    }
  },
  mounted () {
  }
})
